// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1561":"21523e7f","2442":"21523e7f","3733":"da9c9f55","4922":"22bb1b07"}[chunkId] + ".css";
};